import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { extractName } from 'flow/utils';
import { ExtensionKey } from 'flow/types/EntityKeys';

import { selectContact } from 'flow/selectors/ExtensionSelectors';
import useAppContext from 'flow/hooks/useAppContext';
import ContactAvatar from 'flow/components/ui-components/ContactAvatar';
import IconButton from 'flow/components/ui-components/IconButton';
import Icon from 'flow/components/ui-components/Icon';
import { SortableHandle } from 'react-sortable-hoc';
import DragHandleIcon from '@mui/icons-material/DragHandle';

const DragHandle = SortableHandle(() => <DragHandleIcon />);
interface Props {
    agentKey: ExtensionKey;
    onClickDelete: (key: ExtensionKey) => void;
}

const AgentDraggable = ({ onClickDelete, agentKey }: Props) => {
    const { i18next } = useAppContext();

    const contact = useAppSelector((state) => selectContact(state, agentKey));

    return (
        <div
            className="flex w-full items-center justify-between"
            key={`draggable-${agentKey}`}
        >
            <div className="flex items-center gap-x-3 text-sm text-gray-800">
                <ContactAvatar contact={contact} />
                {extractName(contact, i18next.t('Contact.Unknown'))}
            </div>
            <div className="flex items-center gap-x-3 ps-3">
                <IconButton
                    onClick={() => onClickDelete(agentKey)}
                    aria-label={i18next.t('remove')}
                >
                    <Icon iconKey={'delete'} className="fill-gray-500" />
                </IconButton>
                <div className="cursor-pointer">
                    <DragHandle />
                </div>
            </div>
        </div>
    );
};

export default React.memo(AgentDraggable);
